var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/Breadcrumbs/BreadCrumbsRow.tsx";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { Tooltip } from '@gmini/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BreadcrumbsRow = /*#__PURE__*/React.memo(function (_ref) {
  var breadcrumbsNodes = _ref.breadcrumbsNodes,
      detailsButton = _ref.detailsButton,
      onItemClick = _ref.onItemClick;
  var classes = useStyles();
  return /*#__PURE__*/_jsxs("div", {
    className: classes.root,
    children: [detailsButton, breadcrumbsNodes.map(function (breadCrumbNode, i) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: breadCrumbNode.name,
        children: /*#__PURE__*/_jsxs(Typography, {
          onClick: function onClick(e) {
            return onItemClick(breadCrumbNode, e);
          },
          color: "textPrimary",
          noWrap: true,
          variant: "caption",
          className: classes.cursor,
          children: [i !== 0 && /*#__PURE__*/_jsx("span", {
            className: classes.separator,
            children: "/"
          }), breadCrumbNode.name]
        })
      }, breadCrumbNode.key);
    })]
  });
});
BreadcrumbsRow.displayName = 'BreadcrumbsRow';
var useStyles = makeStyles(function () {
  return createStyles({
    root: {
      display: 'flex',
      backgroundColor: '#F1F3FC',
      padding: '0 5px 0 10px',
      position: 'relative',
      alignItems: 'center',
      cursor: 'pointer'
    },
    cursor: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    separator: {
      padding: '0 2px'
    }
  });
});